import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import LoginForm from './LoginForm';
import SplashPage from './SplashPage';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import { useReturnUrl } from '@/utils/returnUrl';
import { BygrModule } from '@ygtechnologies/bygr-frontend-component-library';

type OwnProps = RouteComponentProps<any> & {};

const Login: React.FC<OwnProps> = ({ history, match, location }) => {
    const user = useSelector((state: IState) => state.global.user);
    const isRegister = history.location.pathname.includes('register');
    const navigateToReturnUrl = useReturnUrl(BygrModule.ChangeManagement);
    const handleLogin = () => {
        navigateToReturnUrl();
    };

    if (user && user.isLoggedIn) {
        navigateToReturnUrl();
    }

    return (
        <SplashPage>
            <div style={{ width: '100%' }}>
                <LoginForm onLogin={handleLogin} />
                {/* <LinkTab to="/register" id="register" name={<Trans>Register</Trans>}>
                    <RegisterWizard />
                </LinkTab> */}
            </div>
        </SplashPage>
    );
};

export default withRouter(Login);
